/**
 * Validates and sanitizes search query parameters using Valibot schema.
 * Only redirects if invalid params need to be removed.
 * Does NOT add defaults - composables handle that.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (to.name !== 'search-index') {
    return
  }

  const validated = parseSearchQuery(to.query)

  // Convert validated output to URL query format
  const cleanQuery: Record<string, string> = {}
  for (const [key, value] of Object.entries(validated)) {
    if (value !== undefined) {
      cleanQuery[key] = Array.isArray(value) ? JSON.stringify(value) : String(value)
    }
  }

  const hasInvalidParams = Object.keys(to.query).length > Object.keys(cleanQuery).length

  if (hasInvalidParams) {
    return navigateTo({ ...to, query: cleanQuery }, { replace: true })
  }
})
